import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Альтернативные наименования (через \";\") ", -1)
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6 ModelField-colFirst" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Нормативная ширина (мм)", -1)
const _hoisted_7 = { class: "col-6 ModelField-colLast" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Нормативная высота (мм)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Альтернативные наименования...",
          "show-clear-button": true,
          value: model.alternateNames,
          "onUpdate:value": ($event: any) => ((model.alternateNames) = $event),
          hasEmptyValue: true
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Нормативная ширина ...",
              min: 0,
              hasEmptyValue: false,
              value: model.standardWidth,
              "onUpdate:value": ($event: any) => ((model.standardWidth) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Нормативная высота ...",
              min: 0,
              hasEmptyValue: false,
              value: model.standardHeight,
              "onUpdate:value": ($event: any) => ((model.standardHeight) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}